import { PropsWithChildren, useEffect, useMemo } from "react";
import toast from "react-hot-toast";

import { useDashboardOnboardingControllerDetails } from "@/api/__generated__/dashboard-onboarding/dashboard-onboarding";
import { useCurrentUserContext } from "@/contexts/CurrentUserContext";
import { useT } from "@/i18n";
import { mapToOnboarding } from "@/mappers/onboarding.mappers";

import { OnboardingContext } from "./OnboardingContext";

export const OnboardingProvider = ({ children }: PropsWithChildren) => {
  const { currentUser } = useCurrentUserContext();
  const t = useT();

  const { data, isLoading, error } = useDashboardOnboardingControllerDetails({
    query: {
      enabled: !!currentUser,
    },
  });

  useEffect(() => {
    if (error) {
      toast.error(t("onboarding.errorState.fetchOnboardingDetails"));
    }
  }, [error, t]);

  const contextValue = useMemo(
    () => ({
      onboarding: data ? mapToOnboarding(data) : null,
      loading: isLoading,
    }),
    [data, isLoading]
  );

  return <OnboardingContext.Provider value={contextValue}>{children}</OnboardingContext.Provider>;
};
